// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import httpAjax from './common/http.js'
import publicJs from './common/public.js'
import message from './common/message.js'
import 'default-passive-events'

Vue.use(ElementUI)

Vue.prototype.httpAjax = httpAjax
Vue.prototype.publicJs = publicJs
Vue.prototype.$message = message

Vue.prototype.$realmNameId = httpAjax.readNamePacId;

Vue.prototype.$noData = 'static/images/icon/no-data.png'

Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
  let isMobile = localStorage.getItem('isMobile')
  if (document.documentElement.clientWidth <= 750) {
    isMobile = 1
  } else {
    isMobile = 0
  }
  // eslint-disable-next-line
  if (isMobile == 1) {
    if (to.path === '/' || to.path === '/searchPage' || to.path === '/mapPage') {
      next('/phoneIndex')
    }else if(to.path === '/pageCity'){
      next({path:'/phoneCity',query:to.query})
    }else {
      next()
    }
  } else {
    if (/^\/phone/.test(to.path)) {
      if(to.path==='/phoneCity'){
        next({path:'/pageCity',query:to.query})
      }else {
        next('/');
      }
    } else {
      next();
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data:function () {
    return {
      panIndex:0,
      cityPanIndex:0
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js